import { EThemesOG } from '@/constants/themeConfig';

import * as betgalaxy from './Promos.styles.betgalaxy';
import * as puntgenie from './Promos.styles.puntgenie';
import * as questbet from './Promos.styles.questbet';
import * as wellbet from './Promos.styles.wellbet';
import * as betroyale from './Promos.styles.betroyale';
import * as buffalobet from './Promos.styles.buffalobet';
import * as puntcity from './Promos.styles.puntcity';
import * as sugarcastle from './Promos.styles.sugarcastle';
import * as goldenrush from './Promos.styles.goldenrush';
import * as juicybet from './Promos.styles.juicybet';
import * as vikingbet from './Promos.styles.vikingbet';
import * as volcanobet from './Promos.styles.volcanobet';
import * as oldgill from './Promos.styles.oldgill';
import * as titanbet from './Promos.styles.titanbet';
import * as slambet from './Promos.styles.slambet';
import * as betstride from './Promos.styles.betstride';
import * as templebet from './Promos.styles.templebet';
import * as gigabet from './Promos.styles.gigabet';
import * as goldenbet888 from './Promos.styles.goldenbet888';
import * as chromabet from './Promos.styles.chromabet';
import * as bet777 from './Promos.styles.bet777';
import * as bet575 from './Promos.styles.bet575';
import * as epicodds from './Promos.styles.epicodds';
import * as magnumbet from './Promos.styles.magnumbet';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  puntgenie,
  questbet,
  wellbet,
  betroyale,
  buffalobet,
  puntcity,
  sugarcastle,
  goldenrush,
  juicybet,
  vikingbet,
  volcanobet,
  oldgill,
  titanbet,
  slambet,
  betstride,
  templebet,
  gigabet,
  goldenbet888,
  chromabet,
  bet777,
  bet575,
  epicodds,
  magnumbet,
};
